module.exports = __webpack_public_path__ + "assets/img/Root100_2018_mobile-f20826e0b82b93761121d43473a57be8.jpg";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/Root100_2018_mobile.jpg
// module id = 213
// module chunks = 0